import CompetitionReducer from './CompetitionReducer';
import TrackingReducer from './TrackingReducer';
import LocalReducer from "./LocaleReducer";
import {combineReducers} from 'redux';

const rootReducer = combineReducers({
  bulldogs: CompetitionReducer,
  tracking: TrackingReducer,
  locale:LocalReducer,
});

export default rootReducer;
